/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { USBGrid, USBColumn } from '@usb-shield/react-grid'
import USBButton from '@usb-shield/react-button'
import { PropTypes } from 'prop-types'
import ShieldInput from '../../components/atoms/ShieldInput/ShieldInput'
import PrimeCredentialInput from '../../components/atoms/PrimeCredential/PrimeCredential'
import { loginFieldsSchema } from '../../utils/FieldsUtility'

/**
 * CredentialRecoveryPanel page
 */
const CredentialRecoveryPanel = ({
  clearHandler,
  cancelHandler,
  saveHandler,
  fieldsState = {},
  setFieldState,
  onSensitiveValueChange,
  getCompareToValue,
  credentialResetCounter
}) => {
  return (
    <>
      <USBGrid gridGap="large" addClasses="PageGrid">
        <USBColumn largeSpan={15} addClasses="column">
          <ShieldInput
            fieldSchema={loginFieldsSchema.companyId}
            fieldState={fieldsState.companyId ? fieldsState.companyId : { id: 'companyId', value: '', isError: false, isUserExistsError: false, isFocused: false }}
            setFieldState={setFieldState}
            addClasses="input-darkbg"
          />
        </USBColumn>
      </USBGrid>
      <USBGrid gridGap="large" addClasses="PageGrid">
        <USBColumn largeSpan={15} addClasses="column">
          <ShieldInput
            fieldSchema={loginFieldsSchema.userId}
            fieldState={fieldsState.userId ? fieldsState.userId : { id: 'userId', value: '', isError: false, isUserExistsError: false, isFocused: false }}
            setFieldState={setFieldState}
            addClasses="input-darkbg"
          />
        </USBColumn>
      </USBGrid>
      <USBGrid gridGap="large" addClasses="PageGrid">
        <USBColumn largeSpan={15} addClasses="column">
          <ShieldInput
            fieldSchema={loginFieldsSchema.qid}
            fieldState={fieldsState.qid ? fieldsState.qid : { id: 'qid', value: '', isError: false, isUserExistsError: false, isFocused: false }}
            setFieldState={setFieldState}
            addClasses="input-darkbg"
          />
        </USBColumn>
      </USBGrid>
      <USBGrid gridGap="large" addClasses="PageGrid">
        <USBColumn largeSpan={15} addClasses="column">
          <PrimeCredentialInput
            fieldSchema={loginFieldsSchema.credential}
            fieldState={fieldsState.credential ? fieldsState.credential : { id: 'credential', value: '', isError: false, isUserExistsError: false, isFocused: false }}
            setFieldState={setFieldState}
            onSensitiveValueChange={onSensitiveValueChange}
            addClasses="input-darkbg"
            resetCounter={credentialResetCounter}
            // alwaysShowWeakLabel
            showCredentialStrength
          />
        </USBColumn>
      </USBGrid>
      <USBGrid gridGap="large" addClasses="PageGrid">
        <USBColumn largeSpan={15} addClasses="column">
          <PrimeCredentialInput
            fieldSchema={loginFieldsSchema.confirmCredential}
            fieldState={fieldsState.confirmCredential ? fieldsState.confirmCredential : { id: 'confirmCredential', value: '', isError: false, isUserExistsError: false, isFocused: false }}
            setFieldState={setFieldState}
            onSensitiveValueChange={onSensitiveValueChange}
            addClasses="input-darkbg"
            showCredentialStrength
            compareTo=""
            getCompareToValue={getCompareToValue}
            resetCounter={credentialResetCounter}
            alwaysShowNotMatched
          />
        </USBColumn>
      </USBGrid>
      <USBGrid gridGap="large" addClasses="PageGrid">
        <USBColumn largeSpan={5}>
          <USBButton
            type="button"
            variant="loud"
            size="small"
            ariaLabel="clear"
            id="btnClearUser"
            name="btnClearUser"
            dataTestId="btnClearUser"
            handleClick={clearHandler}
          >
            Clear
          </USBButton>
        </USBColumn>
        <USBColumn largeSpan={6}>
          <USBButton
            type="button"
            variant="utility"
            size="small"
            ariaLabel="clear"
            id="btnClearUser"
            name="btnClearUser"
            dataTestId="btnClearUser"
            handleClick={cancelHandler}
          >
            Cancel
          </USBButton>
        </USBColumn>
        <USBColumn largeSpan={4}>
          <USBButton
            id="btnlogin"
            variant="primary"
            size="small"
            type="button"
            handleClick={saveHandler}
            addClasses="noleftmargin"
          >
            Save
          </USBButton>
        </USBColumn>
      </USBGrid>
    </>
  )
}

CredentialRecoveryPanel.propTypes = {
  fieldsState: PropTypes.objectOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
      isError: PropTypes.bool.isRequired,
      isUserExistsError: PropTypes.bool,
      isFocused: PropTypes.bool.isRequired
    })
  ).isRequired,
  setFieldState: PropTypes.func.isRequired,
  clearHandler: PropTypes.func.isRequired,
  cancelHandler: PropTypes.func.isRequired,
  saveHandler: PropTypes.func.isRequired,
  onSensitiveValueChange: PropTypes.func.isRequired,
  getCompareToValue: PropTypes.func.isRequired,
  credentialResetCounter: PropTypes.number.isRequired
}

export default CredentialRecoveryPanel
